interface BrandLogoProps {
  readonly class?: string;
  readonly compact?: boolean;
}

const BRAND_BASE = `${import.meta.env.BASE_URL}brand/`;

export function BrandLogo({ class: className, compact = false }: BrandLogoProps) {
  return (
    <span class={`brand-logo ${compact ? 'brand-logo-compact' : ''} ${className ?? ''}`.trim()}>
      <img
        src={`${BRAND_BASE}buncha-coasters-logo-transparent.png`}
        alt="Buncha Coasters"
        width="912"
        height="330"
        decoding="async"
      />
    </span>
  );
}
